module.exports = __webpack_public_path__ + "static/media/cover.f790182a.png";